// extracted by mini-css-extract-plugin
export default {"App":"App_App__7v05U","Cookies":"App_Cookies__SM9J9","CookiesText":"App_CookiesText__DDDIQ","CookiesButton":"App_CookiesButton__BbM9c"};